import React, { forwardRef, type ComponentType } from "react";
import { Link, type LinkProps } from "react-router-dom";
import { twMerge } from "tailwind-merge";

interface IMenuButtonProps
  extends LinkProps,
    React.RefAttributes<HTMLAnchorElement> {
  Icon?: ComponentType<React.SVGProps<SVGSVGElement>>;
  badge?: React.ReactNode;
  disabled?: boolean;
  hidden?: boolean;
  active?: boolean;
}

export const MenuButton = forwardRef<HTMLAnchorElement, IMenuButtonProps>(
  (props, ref) => {
    const {
      className,
      Icon,
      children,
      badge,
      disabled,
      hidden,
      active,
      ...rest
    } = props;

    if (hidden) {
      return null;
    }

    return (
      <Link
        className={twMerge(
          "group flex h-10 w-full items-center justify-between truncate rounded-full px-4 py-2 text-left font-medium leading-6 transition-colors hover:bg-grey-light hover:text-base-black",
          active &&
            "bg-blue-light font-semibold text-blue-dark hover:bg-blue-light hover:text-blue-dark",
          disabled &&
            "pointer-events-none cursor-default text-grey-dark hover:bg-base-white hover:text-grey-dark",
          className,
        )}
        ref={ref}
        {...rest}
      >
        <div className="flex items-center gap-3">
          {Icon && (
            <Icon
              className={twMerge(
                "h-5 w-5 text-grey-dark group-disabled:text-grey-dark",
                active && "text-blue-dark",
              )}
            />
          )}
          {children}
        </div>
        {badge && badge}
      </Link>
    );
  },
);
